// src/components/navigation/DesktopNavigation.tsx
import {GenericNavigationBar} from './types'
import {
  Header,
  Nav,
  ReactRouterShortcutLink,
  VerticalRule,
} from '../../styles/navigation.style'
import { TIMELINE_COL_WIDTH_SECOND } from '../../styles/timeline/constants.style'
import {useTimelineDateValue} from '../../contextManager/timelineDate.context'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import useAuth from '../../hooks/auth.service'
import { useLocation } from 'react-router-dom';
import { InitialsAvatarDropdown } from './navDropdowns/InitialsAvatarDropdown'
import { LogoIcon } from '../common/LogoIcon'
import { BookUnderline } from '../common/BookUnderline'
import { BookLogo } from '../common/BookLogo'
import { styled } from '../../styles/stitches.config'
import { BookLessonButton } from './BookLessonButton'

const LogoText = styled('span', {
  fontWeight: 'bold',
  fontSize: '1.3rem',
  lineHeight: '1',
  // color: '$blue12', // Stitches handles this perfectly
  color: 'black',
  letterSpacing: '-0.5px',
});


export const DesktopNavigation: GenericNavigationBar = ({reactRouterLinks}) => {


  
  const location = useLocation();

  // 3. Check if the current path is the timeline page
  //    (Assuming your timeline route is '/timeline'. Change if necessary.)
  const isTimelinePage = location.pathname.startsWith('/strippedTimeline');



  return (
    <Header>
           <Nav>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', minWidth: 0 }}>
          {/* Center TUTOR within fixed width */}
          <Link
            to="/search"
            aria-label="Go to search"
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: TIMELINE_COL_WIDTH_SECOND,
              flexShrink: 0,
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: 'max-content',
                alignItems: 'center',
              }}
            >
              <LogoText>
                tute
              </LogoText>
              <div style={{ width: '100%', height: '14px', marginTop: '0.1rem'}}>
                <BookLogo />
              </div>
            </div>
          </Link>
          <VerticalRule style={{ marginLeft: 0, marginRight: '0.5rem' }} />

          {reactRouterLinks.map(({ to, onClick, title, icon: Icon }, idx) => (
          <ReactRouterShortcutLink key={idx} to={to} onClick={onClick} title={title} >
            <Icon size={22} />
          </ReactRouterShortcutLink>
          ))}
        </div>
        
        {isTimelinePage ? (
          <>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginLeft: '2rem', flexShrink: 0 }}>
          <BookLessonButton />
          <VerticalRule />
          <InitialsAvatarDropdown isMobile={false} reactLinks={reactRouterLinks}/>
          </div>
        </>
        ) : (
          <>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginLeft: '2rem', flexShrink: 0 }}>
          <BookLessonButton />
          <VerticalRule />
          <InitialsAvatarDropdown isMobile={false} reactLinks={reactRouterLinks}/>
          </div>
          </>
        )
        }


      </Nav>
    </Header>
  )
}



